import { render, staticRenderFns } from "./CytomineSlider.vue?vue&type=template&id=4cefaca3&"
import script from "./CytomineSlider.vue?vue&type=script&lang=js&"
export * from "./CytomineSlider.vue?vue&type=script&lang=js&"
import style0 from "./CytomineSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports